import { Button } from "@/components/ui/button";
import { WhatsappIcon } from "@/components/common/whatsapp-brand";
import { capture } from "@/lib/posthog";
import { salesWhatsappLink } from "@/lib/whatsapp";

const CHIPS = [
  "Usuarios a medida",
  "Vistas ilimitadas",
  "API o MCP",
  "Account manager",
];

const CONTACT_LINK = salesWhatsappLink(
  "Hola, quiero cotizar un plan corporativo de Licitigo para mi empresa.",
);

/**
 * Cierra la tabla de precios con el tramo que no cabe en una card: se cotiza a
 * mano, así que su única acción es hablar con el equipo.
 */
export function CorporatePlanBand() {
  return (
    <div className="mt-4 flex flex-col gap-6 rounded-2xl border border-slate-100 bg-white p-6 shadow-sm lg:flex-row lg:items-center lg:justify-between dark:border-slate-800 dark:bg-slate-900">
      <div className="min-w-0">
        <p className="text-[11px] font-bold tracking-widest text-violet-600 uppercase dark:text-violet-400">
          Corporativo
        </p>
        <h3 className="mt-1.5 text-xl font-extrabold tracking-tight text-slate-800 dark:text-slate-100">
          Todo a medida para{" "}
          <span className="text-violet-600 dark:text-violet-400">
            grandes proveedores.
          </span>
        </h3>
        <p className="mt-1.5 max-w-xl text-sm leading-relaxed text-slate-500 dark:text-slate-400">
          Usuarios, vistas y regiones sin tope, API o MCP, CRM corporativo y un
          account manager dedicado. Lo dimensionamos a tu operación.
        </p>
        <div className="mt-4 flex flex-wrap gap-2">
          {CHIPS.map((chip) => (
            <span
              key={chip}
              className="rounded-full border border-violet-100 bg-violet-50 px-2.5 py-1 text-xs font-semibold text-violet-700 dark:border-violet-900/60 dark:bg-violet-950/40 dark:text-violet-300"
            >
              {chip}
            </span>
          ))}
        </div>
      </div>

      <div className="flex shrink-0 flex-col items-start gap-2 lg:items-end">
        <p className="text-base font-extrabold text-slate-800 dark:text-slate-100">
          Precio a medida
        </p>
        {/* Violeta y no azul: es otro tramo de venta, no compite con el "Quiero
            este plan" de las cards. */}
        <Button
          asChild
          className="bg-violet-600 font-bold text-white hover:bg-violet-700"
        >
          <a
            href={CONTACT_LINK}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() =>
              capture("corporate_contact_clicked", { source: "corporate_band" })
            }
          >
            <WhatsappIcon className="size-4" />
            Hablemos por WhatsApp
          </a>
        </Button>
      </div>
    </div>
  );
}
